/* eslint semi:0 */
import networkProvider from '../networkProvider'
import pageDataObject from '../../application/pageDataObject'
import BaseClass from '../../application/BaseClass'

const VBETS_DOMAIN = pageDataObject.get('config.api.vbets_domain')

class VbetsServiceProvider extends BaseClass {
  constructor() {
    super()
  }

  report(url, params) {
    networkProvider
      .safeRequest({
        method: 'POST',
        url: `${VBETS_DOMAIN}/${url}`,
        params: params,
      })
      .then(this.handleVbetResponse.bind(this), this.handleVbetError.bind(this))
  }

  handleVbetResponse(response) {
    this.info(`Vbet Service response is: ${response}`)
  }

  handleVbetError(error) {
    this.warn('Vbets Service request error', error)
  }
}

let vbetsServiceProvider = VbetsServiceProvider.create()
export default vbetsServiceProvider



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/providers/vbetsService/vbetsServiceProvider.js